import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

import {
  ModalContainer,
  ModalContent,
  ModalTitle,
  CloseButton,
  ModalBody,
  Overlay,
  PreventBodyScrolling,
} from './Modal.style';

const Modal = ({
  children,
  title,
  isModalHidden,
  onCloseModal,
  extendModalContainer,
  extendModalContent,
  extendTitleStyle,
  extendModalBody,
}) => {
  const modalContent = useRef(null);
  const modalTitle = useRef(null);
  const modalBody = useRef(null);

  const closeModal = e => {
    if (
      onCloseModal &&
      e.target !== modalContent &&
      e.target !== modalTitle &&
      e.target !== modalBody
    )
      onCloseModal();
  };

  const stopPropagation = e => {
    if (e && e.stopPropagation) e.stopPropagation();
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleEscKeyDown = event => {
    if ('key' in event && (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27)) {
      if (!isModalHidden) {
        closeModal(event);
      }
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleEscKeyDown);

    return () => {
      document.removeEventListener('keydown', handleEscKeyDown);
    };
  }, [handleEscKeyDown]);

  return (
    <>
      <Overlay isModalHidden={isModalHidden} />
      <ModalContainer
        isModalHidden={isModalHidden}
        onClick={closeModal}
        extendStyle={extendModalContainer}
      >
        <PreventBodyScrolling isModalHidden={isModalHidden} />
        <ModalContent
          ref={modalContent}
          onClick={stopPropagation}
          isModalHidden={isModalHidden}
          extendStyle={extendModalContent}
        >
          <ModalTitle ref={modalTitle} extendStyle={extendTitleStyle}>
            {title}
            <CloseButton onClick={closeModal} />
          </ModalTitle>
          <ModalBody ref={modalBody} extendStyle={extendModalBody}>
            {children}
          </ModalBody>
        </ModalContent>
      </ModalContainer>
    </>
  );
};

Modal.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node,
  isModalHidden: PropTypes.bool.isRequired,
  onCloseModal: PropTypes.func,
  extendTitleStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  extendModalContent: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  extendModalBody: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  extendModalContainer: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

Modal.defaultProps = {
  children: '',
  title: '',
  onCloseModal: () => {},
  extendTitleStyle: '',
  extendModalContent: '',
  extendModalBody: '',
  extendModalContainer: '',
};
export default Modal;
